import React from "react";
import { ChatCircleText, Phone } from "@phosphor-icons/react";
import { ActaActionSheet } from "@/components/ui/ActaActionMenu";

export default function ContactCallChannelSheet({
  open,
  phone,
  saving = false,
  onClose,
  onSelect,
  testIdPrefix = "contact",
}) {
  return (
    <ActaActionSheet
      open={open}
      title="Choisir le type d’appel"
      subtitle={phone || "Numéro indisponible"}
      onClose={onClose}
      testId={`${testIdPrefix}-call-channel-sheet`}
    >
      <button
        type="button"
        disabled={saving}
        onClick={() => onSelect?.("phone")}
        className="flex min-h-[56px] w-full items-center gap-3 rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-4 py-3 text-left transition hover:bg-[var(--do-accent-soft)] disabled:opacity-50"
        data-testid={`${testIdPrefix}-call-phone`}
      >
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[var(--do-accent-soft)] text-[var(--do-accent)]">
          <Phone size={20} weight="bold" />
        </span>
        <span>
          <strong className="block text-sm text-[var(--do-ink)]">Appel réseau</strong>
          <small className="mt-0.5 block text-xs text-[var(--do-muted)]">Utiliser l’application téléphone</small>
        </span>
      </button>

      <button
        type="button"
        disabled={saving}
        onClick={() => onSelect?.("whatsapp")}
        className="mt-2 flex min-h-[56px] w-full items-center gap-3 rounded-xl border border-[var(--do-border)] bg-[var(--do-accent-soft)] px-4 py-3 text-left transition hover:bg-[var(--do-accent-soft)] disabled:opacity-50"
        data-testid={`${testIdPrefix}-call-whatsapp`}
      >
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[var(--do-bg-solid)] text-[var(--do-accent)]">
          <ChatCircleText size={20} weight="bold" />
        </span>
        <span>
          <strong className="block text-sm text-[var(--do-ink)]">Ouvrir WhatsApp</strong>
          <small className="mt-0.5 block text-xs text-[var(--do-accent)]">Ouvrir le contact puis lancer l’appel</small>
        </span>
      </button>
    </ActaActionSheet>
  );
}
